import { Route } from 'react-router-dom';

// Builds a <Route> whose element is a layout wrapper. This is a plain FUNCTION, not
// a component — the returned value must be a real <Route> element because react-router
// v6's <Routes> only accepts <Route> elements (or fragments) as children. v6 routes
// are exact by default, so the v5 `exact` flag is accepted and ignored. The layout
// receives the route's match props via the withRouter shim / router hooks, not here.
const layoutRoute = (Layout, { path, exact, ...rest }, key) => (
  <Route key={key || path} path={path} element={<Layout path={path} {...rest} />} />
);

export default layoutRoute;
